// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"JZqT-COo","sign":"_30gQnbk8","smallSign":"_1fvBgKqd","input":"_38Bg9r-T","smallInput":"_1Pv2gw55","tooltipWrapper":"_28akJUHG"};